const abi = JSON.stringify([
	{
		"inputs": [
			{
				"internalType": "string",
				"name": "name",
				"type": "string"
			},
			{
				"internalType": "string",
				"name": "symbol",
				"type": "string"
			},
			{
				"internalType": "uint256",
				"name": "decimals",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "total",
				"type": "uint256"
			},
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "serversAddr",
				"type": "address"
			}
		],
		"stateMutability": "payable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "Approval",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "previousOwner",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "newOwner",
				"type": "address"
			}
		],
		"name": "OwnershipTransferred",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "Transfer",
		"type": "event"
	},
	{
		"inputs": [],
		"name": "VERSION",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			}
		],
		"name": "allowance",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "approve",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "balanceOf",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "decimals",
		"outputs": [
			{
				"internalType": "uint8",
				"name": "",
				"type": "uint8"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "subtractedValue",
				"type": "uint256"
			}
		],
		"name": "decreaseAllowance",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "addedValue",
				"type": "uint256"
			}
		],
		"name": "increaseAllowance",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "name",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "owner",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "renounceOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "symbol",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "totalSupply",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "recipient",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "transfer",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "sender",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "recipient",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "transferFrom",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "newOwner",
				"type": "address"
			}
		],
		"name": "transferOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	}
]);

const bytecode =
    "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";

const abi2 = JSON.stringify(
    [
        {
            "constant": true,
            "inputs": [],
            "name": "name",
            "outputs": [
                {
                    "name": "",
                    "type": "string"
                }
            ],
            "payable": false,
            "stateMutability": "view",
            "type": "function"
        },
        {
            "constant": false,
            "inputs": [
                {
                    "name": "_spender",
                    "type": "address"
                },
                {
                    "name": "_value",
                    "type": "uint256"
                }
            ],
            "name": "approve",
            "outputs": [
                {
                    "name": "",
                    "type": "bool"
                }
            ],
            "payable": false,
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "constant": true,
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "name": "",
                    "type": "uint256"
                }
            ],
            "payable": false,
            "stateMutability": "view",
            "type": "function"
        },
        {
            "constant": false,
            "inputs": [
                {
                    "name": "_from",
                    "type": "address"
                },
                {
                    "name": "_to",
                    "type": "address"
                },
                {
                    "name": "_value",
                    "type": "uint256"
                }
            ],
            "name": "transferFrom",
            "outputs": [
                {
                    "name": "",
                    "type": "bool"
                }
            ],
            "payable": false,
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "constant": true,
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "name": "",
                    "type": "uint256"
                }
            ],
            "payable": false,
            "stateMutability": "view",
            "type": "function"
        },
        {
            "constant": false,
            "inputs": [
                {
                    "name": "_spender",
                    "type": "address"
                },
                {
                    "name": "_subtractedValue",
                    "type": "uint256"
                }
            ],
            "name": "decreaseApproval",
            "outputs": [
                {
                    "name": "success",
                    "type": "bool"
                }
            ],
            "payable": false,
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "constant": true,
            "inputs": [
                {
                    "name": "_owner",
                    "type": "address"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "name": "balance",
                    "type": "uint256"
                }
            ],
            "payable": false,
            "stateMutability": "view",
            "type": "function"
        },
        {
            "constant": true,
            "inputs": [],
            "name": "FeeAddress",
            "outputs": [
                {
                    "name": "",
                    "type": "address"
                }
            ],
            "payable": false,
            "stateMutability": "view",
            "type": "function"
        },
        {
            "constant": true,
            "inputs": [],
            "name": "symbol",
            "outputs": [
                {
                    "name": "",
                    "type": "string"
                }
            ],
            "payable": false,
            "stateMutability": "view",
            "type": "function"
        },
        {
            "constant": false,
            "inputs": [
                {
                    "name": "_to",
                    "type": "address"
                },
                {
                    "name": "_value",
                    "type": "uint256"
                }
            ],
            "name": "transfer",
            "outputs": [
                {
                    "name": "",
                    "type": "bool"
                }
            ],
            "payable": false,
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "constant": true,
            "inputs": [],
            "name": "txFee",
            "outputs": [
                {
                    "name": "",
                    "type": "uint256"
                }
            ],
            "payable": false,
            "stateMutability": "view",
            "type": "function"
        },
        {
            "constant": false,
            "inputs": [
                {
                    "name": "_spender",
                    "type": "address"
                },
                {
                    "name": "_addedValue",
                    "type": "uint256"
                }
            ],
            "name": "increaseApproval",
            "outputs": [
                {
                    "name": "success",
                    "type": "bool"
                }
            ],
            "payable": false,
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "constant": true,
            "inputs": [
                {
                    "name": "_owner",
                    "type": "address"
                },
                {
                    "name": "_spender",
                    "type": "address"
                }
            ],
            "name": "allowance",
            "outputs": [
                {
                    "name": "",
                    "type": "uint256"
                }
            ],
            "payable": false,
            "stateMutability": "view",
            "type": "function"
        },
        {
            "constant": true,
            "inputs": [],
            "name": "burnFee",
            "outputs": [
                {
                    "name": "",
                    "type": "uint256"
                }
            ],
            "payable": false,
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "name": "_name",
                    "type": "string"
                },
                {
                    "name": "_symbol",
                    "type": "string"
                },
                {
                    "name": "_decimals",
                    "type": "uint8"
                },
                {
                    "name": "_totalSupply",
                    "type": "uint256"
                },
                {
                    "name": "adminAddress",
                    "type": "address"
                },
                {
                    "name": "_txFee",
                    "type": "uint8"
                },
                {
                    "name": "_burnFee",
                    "type": "uint8"
                },
                {
                    "name": "_FeeAddress",
                    "type": "address"
                },
                {
                    "name": "_maleDuckAddress",
                    "type": "address"
                }
            ],
            "payable": true,
            "stateMutability": "payable",
            "type": "constructor"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "name": "owner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "name": "spender",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "Approval",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "name": "from",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "name": "to",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "Transfer",
            "type": "event"
        }
    ]
)

const bytecode2 = "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"


const abi3 = JSON.stringify(
	[
		{
			"inputs": [
				{
					"internalType": "string",
					"name": "name_",
					"type": "string"
				},
				{
					"internalType": "string",
					"name": "symbol_",
					"type": "string"
				},
				{
					"internalType": "uint8",
					"name": "decimals_",
					"type": "uint8"
				},
				{
					"internalType": "uint256",
					"name": "totalSupply_",
					"type": "uint256"
				},
				{
					"internalType": "address",
					"name": "adminAddress",
					"type": "address"
				},
				{
					"internalType": "uint8",
					"name": "txFee_",
					"type": "uint8"
				},
				{
					"internalType": "uint8",
					"name": "burnFee_",
					"type": "uint8"
				},
				{
					"internalType": "address payable",
					"name": "FeeAddress",
					"type": "address"
				},
				{
					"internalType": "address",
					"name": "maleDuckAddress_",
					"type": "address"
				},
				{
					"internalType": "uint256[]",
					"name": "uintP",
					"type": "uint256[]"
				}
			],
			"stateMutability": "payable",
			"type": "constructor"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "_blockToUnlockLiquidity",
					"type": "uint256"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "value",
					"type": "uint256"
				}
			],
			"name": "AddLiquidity",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "owner",
					"type": "address"
				},
				{
					"indexed": true,
					"internalType": "address",
					"name": "spender",
					"type": "address"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "value",
					"type": "uint256"
				}
			],
			"name": "Approval",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "lpBalance",
					"type": "uint256"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "burnAmount",
					"type": "uint256"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "time",
					"type": "uint256"
				}
			],
			"name": "AutoNukeLP",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "value",
					"type": "uint256"
				}
			],
			"name": "RemoveLiquidity",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "sender",
					"type": "address"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "amount0In",
					"type": "uint256"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "amount1In",
					"type": "uint256"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "amount0Out",
					"type": "uint256"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "amount1Out",
					"type": "uint256"
				}
			],
			"name": "Swap",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "from",
					"type": "address"
				},
				{
					"indexed": true,
					"internalType": "address",
					"name": "to",
					"type": "address"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "value",
					"type": "uint256"
				}
			],
			"name": "Transfer",
			"type": "event"
		},
		{
			"inputs": [],
			"name": "_burnFee",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "_decimals",
			"outputs": [
				{
					"internalType": "uint8",
					"name": "",
					"type": "uint8"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "",
					"type": "address"
				}
			],
			"name": "_exclueAddr",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "_holdFee",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "_maxWallet",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "_owner",
			"outputs": [
				{
					"internalType": "address",
					"name": "",
					"type": "address"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "_txFee",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "_blockToUnlockLiquidity",
					"type": "uint256"
				}
			],
			"name": "addLiquidity",
			"outputs": [],
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "owner",
					"type": "address"
				},
				{
					"internalType": "address",
					"name": "spender",
					"type": "address"
				}
			],
			"name": "allowance",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "spender",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "amount",
					"type": "uint256"
				}
			],
			"name": "approve",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "account",
					"type": "address"
				}
			],
			"name": "balanceOf",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "blockToUnlockLiquidity",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "currentIndex",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "decimals",
			"outputs": [
				{
					"internalType": "uint8",
					"name": "",
					"type": "uint8"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "dividendGas",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "bool",
					"name": "_maxWalletEnable",
					"type": "bool"
				}
			],
			"name": "enableMaxWallet",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "bool",
					"name": "_tradingEnable",
					"type": "bool"
				}
			],
			"name": "enableTrading",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "value",
					"type": "uint256"
				}
			],
			"name": "extendLiquidityLock",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "feeReceiver",
			"outputs": [
				{
					"internalType": "address payable",
					"name": "",
					"type": "address"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "value",
					"type": "uint256"
				},
				{
					"internalType": "bool",
					"name": "_buy",
					"type": "bool"
				}
			],
			"name": "getAmountOut",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "getReserves",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "holderCondition",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "",
					"type": "address"
				}
			],
			"name": "holderIndex",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "holderRewardCondition",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"name": "holders",
			"outputs": [
				{
					"internalType": "address",
					"name": "",
					"type": "address"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "init",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "lastLpBurnTime",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "liquidityAdded",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "liquidityLock",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "liquidityProvider",
			"outputs": [
				{
					"internalType": "address",
					"name": "",
					"type": "address"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "lpBurnEnabled",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "lpBurnFrequency",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "maxWalletEnable",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "name",
			"outputs": [
				{
					"internalType": "string",
					"name": "",
					"type": "string"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "percentForLPBurn",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "gas",
					"type": "uint256"
				}
			],
			"name": "processReward",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "progressRewardBlock",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "removeLiquidity",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "renounceOwnership",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "router",
			"outputs": [
				{
					"internalType": "address payable",
					"name": "",
					"type": "address"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "_frequencyInSeconds",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "_percent",
					"type": "uint256"
				},
				{
					"internalType": "bool",
					"name": "_Enabled",
					"type": "bool"
				}
			],
			"name": "setAutoLPBurnSettings",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "vgas",
					"type": "uint256"
				}
			],
			"name": "setDividendGas",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "exclueAddr",
					"type": "address"
				},
				{
					"internalType": "bool",
					"name": "value",
					"type": "bool"
				}
			],
			"name": "setExclueAddr",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "amount",
					"type": "uint256"
				}
			],
			"name": "setHolderCondition",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "amount",
					"type": "uint256"
				}
			],
			"name": "setHolderRewardCondition",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "bool",
					"name": "value",
					"type": "bool"
				}
			],
			"name": "setLpBurnEnabled",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "_maxWallet_",
					"type": "uint256"
				}
			],
			"name": "setMaxWallet",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "symbol",
			"outputs": [
				{
					"internalType": "string",
					"name": "",
					"type": "string"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "totalSupply",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "tradingEnable",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "to",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "value",
					"type": "uint256"
				}
			],
			"name": "transfer",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "sender",
					"type": "address"
				},
				{
					"internalType": "address",
					"name": "recipient",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "amount",
					"type": "uint256"
				}
			],
			"name": "transferFrom",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "withRouterBNB",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"stateMutability": "payable",
			"type": "receive"
		}
	]
)

const bytecode3 = "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"


export { abi, bytecode, abi2, bytecode2, abi3, bytecode3 };
